import React, { useContext, useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider, theme } from "antd";
import DashboardLayout from "./components/layout/DashboardLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

import Users from "./pages/Users";
import Profile from "./pages/Profile";
import Survey from "./pages/Survey";
import SurveyMap from "./pages/SurveyMap";
import Departments from "./pages/Departments";
import { Context } from "./context/Context";
import useAuthApis from "./apis/useAuthApis";
import ChangePassword from "./pages/ChangePassword";
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from "./pages/ResetPassword";
import Wards from "./pages/Wards";
import Mohallas from "./pages/Mohallas";
import Constructions from "./pages/Constructions";
import PropertyCategories from "./pages/PropertyCategory";
import PropertyCommercialCategories from "./pages/PropertyCommercialCategory";
import PropertyCommercialSubCategories from "./pages/PropertyCommercialSubCategory";
import PropertyStatus from "./pages/PropertyStatus";
import PropertyType from "./pages/PropertyType";
import SessionExpired from "./pages/SessionExpired";
import SurveyDetails from "./pages/SurveyDetails";


function App() {
  const [firstLoading, setFirstLoading] = useState(true);

  const { isAuthorized, isLoading,setIsAuthorized, setIsLoading, userData } =
    useContext(Context);

  const { homeApi } = useAuthApis();


const checkLogin = async () => {
  setIsLoading(true);
  try {
    const res = await homeApi(); // This should confirm user is logged in
    setIsAuthorized(true);
  } catch (err) {
    setIsAuthorized(false);
    localStorage.removeItem("bearerToken");
  } finally {
    setFirstLoading(false);
    setIsLoading(false);
  }
};

useEffect(() => {
  const token = localStorage.getItem("bearerToken");
  if (token) {
    checkLogin(); // Always check login if token exists
  } else {
    setIsAuthorized(false);
    setFirstLoading(false); // No token, no need to check
  }

  const interval = setInterval(() => {
    const isTabActive = !document.hidden;
    if (isTabActive && localStorage.getItem("bearerToken")) {
      checkLogin();
      homeApi();
    }
  }, 1000);

  return () => clearInterval(interval);
}, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1890ff",
          borderRadius: 6,
          colorBgContainer: "#ffffff",
          colorBgElevated: "#ffffff",
          colorText: "rgba(0, 0, 0, 0.85)",
          colorTextSecondary: "rgba(0, 0, 0, 0.45)",
        },
        algorithm: theme.defaultAlgorithm,
      }}
    >
      {!firstLoading ? (
        isAuthorized ? (
          <Routes>
            <Route
              path="/"
              element={
                <DashboardLayout>
                  <Dashboard />
                </DashboardLayout>
              }
            />

            <Route
              path="/survey"
              element={
                <DashboardLayout>
                  <Survey />
                </DashboardLayout>
              }
            />
            <Route
              path="/survey-map"
              element={
                <DashboardLayout>
                  <SurveyMap />
                </DashboardLayout>
              }
            />

            <Route
              path="/departments"
              element={
                <DashboardLayout>
                  <Departments />
                </DashboardLayout>
              }
            />

            <Route
              path="/users"
              element={
                <DashboardLayout>
                  <Users />
                </DashboardLayout>
              }
            />
            <Route
              path="/wards"
              element={
                <DashboardLayout>
                  <Wards />
                </DashboardLayout>
              }
            />
            <Route
              path="/mohallas"
              element={
                <DashboardLayout>
                  <Mohallas />
                </DashboardLayout>
              }
            />

            <Route
              path="/categories"
              element={
                <DashboardLayout>
                  <PropertyCategories />
                </DashboardLayout>
              }
            />

            <Route
              path="/commercial-categories"
              element={
                <DashboardLayout>
                  <PropertyCommercialCategories />
                </DashboardLayout>
              }
            />

            <Route
              path="/commercial-sub-categories"
              element={
                <DashboardLayout>
                  <PropertyCommercialSubCategories />
                </DashboardLayout>
              }
            />
            <Route
              path="/constructions"
              element={
                <DashboardLayout>
                  <Constructions />
                </DashboardLayout>
              }
            />

            <Route
              path="/property-status"
              element={
                <DashboardLayout>
                  <PropertyStatus />
                </DashboardLayout>
              }
            />

            <Route
              path="/property-type"
              element={
                <DashboardLayout>
                  <PropertyType />
                </DashboardLayout>
              }
            />


            <Route
              path="/profile"
              element={
                <DashboardLayout>
                  <Profile />
                </DashboardLayout>
              }
            />
            <Route
              path="/surveys"
              element={
                <DashboardLayout>
                  <Survey />
                </DashboardLayout>
              }
            />
            <Route
              path="/change-password"
              element={
                <DashboardLayout>
                  <ChangePassword />
                </DashboardLayout>
              }
            />
            <Route
              path="/survey/:id"
              element={
                <DashboardLayout>
                  <SurveyDetails />
                </DashboardLayout>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/session-expired" element={<SessionExpired />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Login />} />
          </Routes>
        )
      ) : (
        <></>
      )}
    </ConfigProvider>
  );
}

export default App;


